var TYPE_APPLY_NOW = 1;
module.exports.TYPE_APPLY_NOW = TYPE_APPLY_NOW;

var TYPE_BOOK_NOW = 2;
module.exports.TYPE_BOOK_NOW = TYPE_BOOK_NOW;

var TYPE_CONTACT_US = 3;
module.exports.TYPE_CONTACT_US = TYPE_CONTACT_US;

var TYPE_DOWNLOAD = 4;
module.exports.TYPE_DOWNLOAD = TYPE_DOWNLOAD;

var TYPE_LEARN_MORE = 5;
module.exports.TYPE_LEARN_MORE = TYPE_LEARN_MORE;

var TYPE_SHOP_NOW = 6;
module.exports.TYPE_SHOP_NOW = TYPE_SHOP_NOW;

var TYPE_SIGN_UP = 7;
module.exports.TYPE_SIGN_UP = TYPE_SIGN_UP;

var TYPE_WATCH_MORE = 8;
module.exports.TYPE_WATCH_MORE = TYPE_WATCH_MORE;

var TYPE_REQUEST_TIME = 9;
module.exports.TYPE_REQUEST_TIME = TYPE_REQUEST_TIME;

var TYPE_SEE_MENU = 10;
module.exports.TYPE_SEE_MENU = TYPE_SEE_MENU;

var TYPE_BUY_NOW = 11;
module.exports.TYPE_BUY_NOW = TYPE_BUY_NOW;

var TYPE_CALL_NOW = 12;
module.exports.TYPE_CALL_NOW = TYPE_CALL_NOW;

var TYPE_GET_DIRECTIONS = 13;
module.exports.TYPE_GET_DIRECTIONS = TYPE_GET_DIRECTIONS;

var TYPE_GET_QUOTE = 14;
module.exports.TYPE_GET_QUOTE = TYPE_GET_QUOTE;

var TYPE_INSTALL_APP = 15;
module.exports.TYPE_INSTALL_APP = TYPE_INSTALL_APP;

var TYPE_LIKE_PAGE = 16;
module.exports.TYPE_LIKE_PAGE = TYPE_LIKE_PAGE;

var TYPE_LISTEN_MUSIC = 17;
module.exports.TYPE_LISTEN_MUSIC = TYPE_LISTEN_MUSIC;

var TYPE_MESSAGE_PAGE = 18;
module.exports.TYPE_MESSAGE_PAGE = TYPE_MESSAGE_PAGE;

var TYPE_OPEN_LINK = 19;
module.exports.TYPE_OPEN_LINK = TYPE_OPEN_LINK;

var TYPE_PLAY_GAME = 21;
module.exports.TYPE_PLAY_GAME = TYPE_PLAY_GAME;

var TYPE_SUBSCRIBE = 22;
module.exports.TYPE_SUBSCRIBE = TYPE_SUBSCRIBE;

var TYPE_USE_APP = 23;
module.exports.TYPE_USE_APP = TYPE_USE_APP;

var TYPE_WATCH_VIDEO = 24;
module.exports.TYPE_WATCH_VIDEO = TYPE_WATCH_VIDEO;

var TYPE_SAVE = 25;
module.exports.TYPE_SAVE = TYPE_SAVE;

var TYPE_DONATE_NOW = 26;
module.exports.TYPE_DONATE_NOW = TYPE_DONATE_NOW;

var TYPE_GO_LIVE = 27;
module.exports.TYPE_GO_LIVE = TYPE_GO_LIVE;

var TYPE_BUY_TICKETS = 28;
module.exports.TYPE_BUY_TICKETS = TYPE_BUY_TICKETS;

var TYPE_BET_NOW = 29;
module.exports.TYPE_BET_NOW = TYPE_BET_NOW;

var TYPE_ADD_TO_CART = 30;
module.exports.TYPE_ADD_TO_CART = TYPE_ADD_TO_CART;

var TYPE_ORDER_NOW = 31;
module.exports.TYPE_ORDER_NOW = TYPE_ORDER_NOW;

var TYPE_SELL_NOW = 32;
module.exports.TYPE_SELL_NOW = TYPE_SELL_NOW;

var TYPE_CALL_ME = 33;
module.exports.TYPE_CALL_ME = TYPE_CALL_ME;

var TYPE_REGISTER_NOW = 34;
module.exports.TYPE_REGISTER_NOW = TYPE_REGISTER_NOW;

var TYPE_EVENT_RSVP = 35;
module.exports.TYPE_EVENT_RSVP = TYPE_EVENT_RSVP;

var CTA_DATA = {
  [TYPE_APPLY_NOW]:'Apply Now',
  [TYPE_BOOK_NOW]:'Book Now',
  [TYPE_BUY_NOW]:'Buy Now',
  [TYPE_CALL_NOW]:'Call Now',
  [TYPE_CONTACT_US]:'Contact Us',
  [TYPE_DOWNLOAD]:'Download',
  [TYPE_GET_DIRECTIONS]:'Get Directions',
  [TYPE_GET_QUOTE]:'Get Quote',
  [TYPE_INSTALL_APP]:'Install Now',
  [TYPE_LEARN_MORE]:'Learn More',
  [TYPE_LIKE_PAGE]:'Like Page',
  [TYPE_LISTEN_MUSIC]:'Listen now',
  [TYPE_OPEN_LINK]:'Open Link',
  [TYPE_PLAY_GAME]:'Play Game',
  [TYPE_REQUEST_TIME]:'Request Time',
  [TYPE_SEE_MENU]:'See Menu',
  [TYPE_SHOP_NOW]:'Shop Now',
  [TYPE_SIGN_UP]:'Sign Up',
  [TYPE_SUBSCRIBE]:'Subscribe',
  [TYPE_MESSAGE_PAGE]:'Send Message',
  [TYPE_USE_APP]:'Use App',
  [TYPE_WATCH_VIDEO]:'Watch Video',
  [TYPE_WATCH_MORE]:'Watch More',
  [TYPE_SAVE]:'Save',
  [TYPE_DONATE_NOW]:'Donate Now',
  [TYPE_GO_LIVE]:'Go Live',
  [TYPE_BUY_TICKETS]:'Buy Tickets',
  [TYPE_BET_NOW]:'Bet Now',
  [TYPE_ADD_TO_CART]:'Add To Cart',
  [TYPE_ORDER_NOW]:'Order Now',
  [TYPE_SELL_NOW]:'Sell Now',
  [TYPE_CALL_ME]:'Free Call',
  [TYPE_REGISTER_NOW]:'Register Now',
  [TYPE_EVENT_RSVP]:'View Event',
};
module.exports.CTA_DATA = CTA_DATA;
